export const FETCH_GRAPHICS_REQUEST = "API/ENTITIES/GRAPHICS/REQUEST";
export const FETCH_GRAPHICS_REQUEST_SUCCESS =
  "API/ENTITIES/GRAPHICS/REQUEST_SUCCESS";
export const FETCH_GRAPHICS_REQUEST_FAILURE =
  "API/ENTITIES/GRAPHICS/REQUEST_FAILURE";

export const CLEAR_GRAPHICS_REQUEST = "API/ENTITIES/GRAPHICS/CLEAR_REQUEST";
